import antdEnUS from "antd/es/locale/en_US";
import antdFrFR from "antd/es/locale/fr_FR";
import antdArEg from "antd/es/locale/ar_EG";
import { THEME_CONFIG } from "configs/AppConfig";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en_US.json";
import fr from "./locales/fr_FR.json";
import ar from "./locales/ar_EG.json";
export const resources = {
  en: {
    translation: en,
    antd: antdEnUS,
  },
  fr: {
    translation: fr,
    antd: antdFrFR,
  },
  ar: {
    translation: ar,
    antd: antdArEg,
  },
};
let savedLanguage;
try {
  savedLanguage = JSON.parse(localStorage.getItem("theme"))?.locale;
} catch (error) {
  console.error("Error parsing language from localStorage:", error);
}

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: THEME_CONFIG.locale,
  lng: savedLanguage || THEME_CONFIG.locale,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
